var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_1687)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.806 148.533H40.1938V31.4714H129.806V148.533Z",
    fill: "#0F766E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.659 143.417H44.3413V36.5876H125.659V143.417Z",
    fill: "#DEEBEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9266 28.6728C92.5194 24.6324 89.1473 21.4666 84.9996 21.4666C80.8531 21.4666 77.481 24.6324 77.0737 28.6731L92.9266 28.6728Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.819 37.8812H64.1812V27.1716H105.819V37.8812Z",
    fill: "#0F766E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6866 59.3076H56.4053V72.5889H69.6866V59.3076Z",
    fill: "#0F766E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9433 64.5591L92.2101 69.8261L110.778 51.2585L113.595 54.0757L93.6187 74.0517L92.2101 75.4604L90.8015 74.0517L84.126 67.3762L86.9433 64.5591Z",
    fill: "#0F766E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6866 85.9504H56.4053V99.2318H69.6866V85.9504Z",
    fill: "#0F766E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9433 91.2023L92.2101 96.4691L110.778 77.9014L113.595 80.7185L93.6187 100.694L92.2101 102.103L90.8015 100.694L84.126 94.0187L86.9433 91.2023Z",
    fill: "#0F766E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6866 112.594H56.4053V125.875H69.6866V112.594Z",
    fill: "#0F766E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9433 117.845L92.2101 123.112L110.778 104.544L113.595 107.361L93.6187 127.337L92.2101 128.746L90.8015 127.337L84.126 120.662L86.9433 117.845Z",
    fill: "#0F766E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_1687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 170,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.2a040e1ed876af327e20b73f1a216da7.svg";
export { ForwardRef as ReactComponent };